import FundingInstructions from './FundingInstructions';

export default FundingInstructions;
